import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HistoryChatLogsComponent } from './history-chat-logs/history-chat-logs.component';
import { ButtonModule } from 'primeng/button';
import { NgClass } from '@angular/common';
import { ChatLogService } from './chat-log.service';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CalendarModule } from 'primeng/calendar';
import { PropertyService } from '../properties/service/property.service';
import { DropdownModule } from 'primeng/dropdown';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-chat-logs',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    DatePipe,
    CommonModule,
    IconFieldModule,
    InputIconModule,
    TableModule,
    HistoryChatLogsComponent,
    NgIf,
    ButtonModule,
    NgClass,
    FormsModule,
    CalendarModule,
    DropdownModule
  ],
  templateUrl: './chat-logs.component.html',
  styleUrl: './chat-logs.component.scss'
})
export class ChatLogsComponent {
  isOpen = false;
  logs = [];
  filters: any = { start: 1 }; // Default to last X days`
  selectedChat: any = null;
  contactInfo: any = null;
  isLoading = false;
  dateRange: Date[] = [];
  // agents: any[] = [];
  leadSourceOptions = [
    { label: 'All',  value: '' },
    { label: 'CALL', value: 'callbot' },
    { label: 'SMS',  value: 'textbot' },
    { label: 'WEB',  value: 'chatbot' },
  ];
  isToggled: boolean = false;
  propertyId: string = '';
  propertyTimezone: string = '';
  blockSpecialCharsPattern = /[.*+?^${}()|[\]\\]/g;
  hostName = window.location.hostname;
  totalRecords: number = 0;
  currentPage: number = 0;
  itemsPerPage = 10;
  sorting: any = {
    field: '',
    order: 1
  };
  user: any = [];

  constructor(
    private chatLogService: ChatLogService,
    private propertyService: PropertyService,
  ) { }

  onRowSelect(event: any) {
    this.selectedChat = event.data;
    this.contactInfo = event.data.contactInfo;
    this.isOpen = true;
  }

  closeChatHistory() {
    this.isOpen = false
  }

  async ngOnInit() {
    // const today = new Date();
    // const nextWeek = new Date();
    // nextWeek.setDate(today.getDate() + 7);
    // this.dateRange = [today, nextWeek];
    try {
      await this.getChatLogs({
        first: this.currentPage * this.itemsPerPage,
        rows: this.itemsPerPage,
      });
      this.user = await firstValueFrom(this.propertyService.getUserInfo());
      this.propertyId = this.user.property_id;
      this.propertyTimezone = this.user.property?.timezone || '';
      const res = await this.chatLogService.getChatBotShowSetting(this.propertyId);
      this.isToggled = res?.isToggled ?? false;
    } catch (error) {
      console.error('Error fetching chatbot setting:', error);
    } finally {
      //this.loading = false;
    }
  }

  async getChatLogs(params: any) {
    const first = params?.first || 0;
    const rows = params?.rows || 10;
    const sortField = params?.sortField || 'chat_date';
    const sortOrder = params?.sortOrder || '1';
    const page = first / rows + 1;
    const limit = rows;
    const queryParams = {
      page,
      limit,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    this.isLoading = false;
    (await this.chatLogService.getLogs(this.filters, queryParams)).subscribe({
      next: (res: any) => {
        this.logs = (res?.data ?? res).map((log: any) => {
          if (log.source === 'textbot') log.source = 'SMS';
          else if (log.source === 'chatbot') log.source = 'WEB';
          else if (log.source === 'callbot') log.source = 'CALL';
          return log;
        });
        this.totalRecords = res.total ?? this.logs.length;
        this.currentPage = page - 1;
        console.log("Current PAGE:", this.currentPage, "Total Records:", this.totalRecords);
        console.log("CHAT LOGS >>>>", res);
      },
      error: (err) => {
        console.error(`Failed to load`, err);
      }
    });
    this.isLoading = false;
    // this.propertyService.getTenants({}).subscribe(res => {
    //   this.agents = res.data.map((tenant: any) => ({
    //     label: tenant.first_name + ' ' + tenant.last_name,
    //     value: tenant.first_name + ' ' + tenant.last_name
    //   }));
    //   this.agents.push({ label: 'To Be Assigned', value: 'To Be Assigned' });
    // });
  }

  onDateRangeChange() {
    if (this.dateRange && this.dateRange.length === 2) {
      const [start, end] = this.dateRange;
      const timezoneOffsetMinutes = new Date().getTimezoneOffset();
      if (!start && !end) {
        return;
      }
      this.filters.timezoneOffset = timezoneOffsetMinutes;
      console.log("Timezone Offset Minutes:", timezoneOffsetMinutes);
      if (start) {
        this.filters.startDate = start;
      }
      if (end) {
        this.filters.endDate = end;
      }
    } else {
      delete this.filters.startDate;
      delete this.filters.endDate;
    }
    console.log("FILTERS >>>>>>>>>>>", this.filters);
    this.getChatLogs({ first: this.currentPage * this.itemsPerPage, rows: this.itemsPerPage });
  }

  onSourceChange() {
    this.getChatLogs({
      first: this.currentPage * this.itemsPerPage,
      rows: this.itemsPerPage,
    });
  }

  onResidentChange() {
    this.getChatLogs({
      first: this.currentPage * this.itemsPerPage,
      rows: this.itemsPerPage,
    });
  }

  onSorting(event: any): void {
    this.sorting.field = event.field;
    this.sorting.order = event.order;
    this.getChatLogs({
      first: this.currentPage * this.itemsPerPage,
      rows: this.itemsPerPage,
    });
  }

  private formatDate(time: any): string {
    if (!time) return '—';
    const date = new Date(time);
    if (isNaN(date.getTime())) return '—';
    const tz = this.propertyTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    return new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: tz,
    }).format(date);
  }

  formatChatDate(log: any): string {
    return this.formatDate(log?.history?.[0]?.time);
  }

  formatRecentActivity(log: any): string {
    return this.formatDate(log?.contactInfo?.chat_date);
  }

  toggleChanged() {
    this.isToggled = this.isToggled;
    this.chatLogService.updateChatBotShowSetting({ propertyId: this.propertyId, isToggled: this.isToggled }).then(() => {
      console.log('Chatbot show setting updated:', this.isToggled);
    }).catch(error => {
      console.error('Error updating chatbot show setting:', error);
    });
  }

  // Block on typing
  blockSpecialChars(event: KeyboardEvent) {
    console.log("BLOCK typing");
    if (this.blockSpecialCharsPattern.test(event.key)) {
      event.preventDefault();
    }
  }

  // Block on paste
  blockSpecialCharsOnPaste(event: ClipboardEvent) {
    console.log("BLOCK PASTE");
    const pasteData = event.clipboardData?.getData('text') || '';
    if (this.blockSpecialCharsPattern.test(pasteData)) {
      event.preventDefault();
    }
  }

  // Block on drop
  blockSpecialCharsOnDrop(event: DragEvent) {
    console.log("BLOCK Drop");
    const dropData = event.dataTransfer?.getData('text') || '';
    if (this.blockSpecialCharsPattern.test(dropData)) {
      event.preventDefault();
    }
  }

  // Final cleanup in case something sneaks in
  sanitizeInput(event: Event) {
    console.log("SANITIZE INPUT");
    const input = event.target as HTMLInputElement;
    if (this.blockSpecialCharsPattern.test(input.value)) {
      input.value = input.value.replace(this.blockSpecialCharsPattern, '');
    }
  }
}